export default function backToStep({ state }, newStepNumber) {
  const onboarding = state.select(['onboarding']);

  onboarding.set(['currentStepNumber'], newStepNumber);

  state.commit();
}
